import React from "react";
import { initI18nFromSSR } from "./i18n/initFromSSR";
import ProductPublicReviewList from "./features/productdetail/ProductPublicReviewList";
import { getNumberAttribute } from "../frontend/bootstrap/runtime";
import {
  IslandRegistry,
  mountIsland,
} from "../frontend/bootstrap/islandRegistry";

// Initialize i18n from SSR data và đợi load xong trước khi render
initI18nFromSSR().then(() => {
  const registry = new IslandRegistry();

  registry.register("productReviews", () => {
    mountIsland("reviews-container", (root) => {
      const productId = getNumberAttribute(root, "data-product-id", 0);
      if (!productId) {
        return null;
      }

      return <ProductPublicReviewList productId={productId} />;
    });
  });

  registry.mount("productReviews");
});

